import {
  PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_BEGIN,
  PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_SUCCESS,
  PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_FAILURE,
  PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { REACT_APP_PRECIOJUSTO_API } from '../../../common/config'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actBatchSearchResult(pagination, args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_BEGIN,
    })

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      let brandFilter = ''
      let modelFilter = ''
      let yearFilter = ''

      if (args.brand) {
        brandFilter = `&filter[where][brand]=${args.brand}`
      }

      if (args.model) {
        modelFilter = `&filter[where][model]=${args.model}`
      }

      if (args.year) {
        yearFilter = `&filter[where][year]=${args.year}`
      }

      const doRequest = axios.get(
        `${REACT_APP_PRECIOJUSTO_API}/BatchSearchResults/grouped?filter[where][and][0][searchDate][gte]=${args.dateStart}&filter[where][and][1][searchDate][lte]=${args.dateEnd}${brandFilter}${modelFilter}${yearFilter}${pagination}`,
      )

      doRequest.then(
        (res) => {
          dispatch({
            type: PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_SUCCESS,
            data: res.data,
          })
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActBatchSearchResultError() {
  return {
    type: PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actBatchSearchResultPending: true,
        actBatchSearchResultError: null,
      }

    case PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_SUCCESS:
      // The request is success
      return {
        ...state,
        actBatchSearchResultPending: false,
        actBatchSearchResultError: null,
        batchResults: action.data,
      }

    case PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_FAILURE:
      // The request is failed
      return {
        ...state,
        actBatchSearchResultPending: false,
        actBatchSearchResultError: action.data.error,
      }

    case PRECIO_JUSTO_ACT_BATCH_SEARCH_RESULT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actBatchSearchResultError: null,
      }

    default:
      return state
  }
}
